export default __webpack_public_path__ + "static/media/standard_layout.9505a166.png";